import { HeadingPhrases } from './HeadingPhrases'
import { useTranslation } from 'react-i18next'
import { Icon } from '@/components/ui/icon'
import { SHOPIFY_APP_STORE_URL } from '@/config/public-links'

const STAGE_KEYS = ['found', 'described', 'buyable'] as const

/** Illustrative Findings explain the product; they never represent a visitor's store. */
export function StoreCheck() {
  const { t } = useTranslation()
  return (
    <section id="store-check" aria-labelledby="store-check-title" className="lp-section lp-store-section">
      <div className="lp-container">
        <div className="lp-section-intro lp-centered">
          <p className="lp-eyebrow">{t('landing:store_check.eyebrow')}</p>
          <h2 id="store-check-title"><HeadingPhrases text={t('landing:store_check.title')} /></h2>
          <p>{t('landing:store_check.description')}</p>
        </div>
        <div className="lp-store-layout">
          <ol className="lp-stages">
            {STAGE_KEYS.map((key, index) => (
              <li key={key}>
                <span className="lp-stage-number" aria-hidden>{String(index + 1).padStart(2, '0')}</span>
                <div>
                  <h3>{t(`landing:store_check.items.${key}.title`)}</h3>
                  <p className="lp-stage-question">{t(`landing:store_check.items.${key}.question`)}</p>
                  <p>{t(`landing:store_check.items.${key}.body`)}</p>
                </div>
              </li>
            ))}
          </ol>
          <figure className="lp-check-example">
            <figcaption>{t('landing:store_check.preview.label')}</figcaption>
            <div className="lp-check-sheet">
              <div className="lp-check-heading"><span>{t('landing:store_check.preview.shop')}</span><span className="lp-example-status">{t('landing:store_check.preview.status')}</span></div>
              <div className="lp-priority">
                <span className="lp-priority-label">{t('landing:store_check.preview.priority')}</span>
                <h3>{t('landing:store_check.preview.title')}</h3>
                <p>{t('landing:store_check.preview.body')}</p>
                <div className="lp-example-product">
                  <span className="lp-product-monogram" aria-hidden>eo.</span>
                  <div><strong>{t('landing:store_check.preview.product')}</strong><span>{t('landing:store_check.preview.category')} · {t('landing:store_check.preview.missing')}</span></div>
                </div>
                <p className="lp-example-next">{t('landing:store_check.preview.action')} <Icon name="nav.arrowRight" size="sm" aria-hidden /></p>
              </div>
              <div className="lp-example-row"><span>{t('landing:store_check.preview.image')}</span><span>✓ {t('landing:store_check.preview.ready')}</span></div>
              <div className="lp-example-row"><span>{t('landing:store_check.preview.policy')}</span><span>✓ {t('landing:store_check.preview.ready')}</span></div>
            </div>
            <div className="lp-recheck-note"><span aria-hidden>↻</span><div><strong>{t('landing:store_check.preview.recheck')}</strong><p>{t('landing:store_check.preview.recheck_body')}</p></div></div>
          </figure>
        </div>
        <p className="lp-check-boundary">{t('landing:store_check.boundary')}</p>
        <div className="lp-centered mt-10">
          <a className="lp-button" href={SHOPIFY_APP_STORE_URL}>
            {t('landing:nav.install')}<Icon name="nav.arrowRight" size="sm" aria-hidden />
          </a>
        </div>
      </div>
    </section>
  )
}
